var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ButtonLink from '@web/components/layout/Button/ButtonLink';
import DangerButton from '@web/components/layout/Button/DangerButton';
import PrimaryButtonDark from '@web/components/layout/Button/PrimaryButtonDark';
import PrimaryButton from '@web/components/layout/Button/PrimaryButtonOutline';
import RedButton from '@web/components/layout/Button/RedButton';
import WhiteButton from '@web/components/layout/Button/WhiteButton';
var Button = function (props) {
    var variant = props.variant;
    if (variant === 'primary')
        return _jsx(PrimaryButton, __assign({}, __assign({}, props)));
    if (variant === 'primaryDark')
        return _jsx(PrimaryButtonDark, __assign({}, __assign({}, props)));
    if (variant === 'white')
        return _jsx(WhiteButton, __assign({}, __assign({}, props)));
    if (variant === 'red')
        return _jsx(RedButton, __assign({}, __assign({}, props)));
    if (variant === 'danger')
        return _jsx(DangerButton, __assign({}, __assign({}, props)));
    if (variant === 'link')
        return _jsx(ButtonLink, __assign({}, __assign({}, props)));
    return null;
};
export default Button;
